<div class="popular_products_container laptop_margin position_relative" *ngIf="popularProducts?.length" [ngClass]="{mt_40 : prodSingle}" >
  <div class="popular_products_container--title mb_40" *ngIf="!prodSingle">
<!--    {{isMobile ? ('product.catalog.other_products' | translate) : ('product.catalog.popular_products' | translate)}}-->
    {{'catalog.popular_products' | translate}}
    <span class="city_name">
       {{cityName}}
    </span>
  </div>
<!--  <app-custom-slider>-->
  <div class="popular_products_cards" [ngClass]="{prod_single: prodSingle}" >
    <div *ngFor="let item of popularProducts" class="h_100 items" [ngClass]="{m_r_5_i: prodSingle}">
      <app-product-card [productCard]="item"
                        [numOfColumns]="3"
                        [type]="productCardTypeEnum.POPULAR"
                        [componentType]="componentType || productCardTypeEnum.POPULAR"
      ></app-product-card>
    </div>
  </div>
<!--  </app-custom-slider>-->
</div>
